module.exports = __webpack_public_path__ + "static/ipe_chart-e7d9d611599a82408061f5f4477485d8.jpg";